import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import { setupStore } from '@/store'
import i18n from '@/lang/index'
import 'default-passive-events'
import '@/permission'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/index.scss'
import 'uno.css'

// 过滤浏览器扩展的控制台日志（双重保险）
if (typeof console !== 'undefined' && !console._filtered) {
  const filterMessage = function(...args) {
    const message = args.map(arg => {
      if (typeof arg === 'string') return arg
      if (typeof arg === 'object') {
        try {
          return JSON.stringify(arg)
        } catch (e) {
          // 处理循环引用，使用对象的字符串表示
          try {
            return String(arg)
          } catch (e2) {
            return '[Object]'
          }
        }
      }
      return String(arg)
    }).join(' ')
    return message.includes('[Request Capture]')
  }
  
  const originalLog = console.log
  const originalInfo = console.info
  const originalDebug = console.debug
  const originalWarn = console.warn
  
  console.log = function(...args) {
    if (!filterMessage(...args)) {
      originalLog.apply(console, args)
    }
  }
  
  console.info = function(...args) {
    if (!filterMessage(...args)) {
      originalInfo.apply(console, args)
    }
  }
  
  console.debug = function(...args) {
    if (!filterMessage(...args)) {
      originalDebug.apply(console, args)
    }
  }
  
  console.warn = function(...args) {
    if (!filterMessage(...args)) {
      originalWarn.apply(console, args)
    }
  }
  
  console._filtered = true
}

const app = createApp(App)
setupStore(app)
app.use(router)
app.use(i18n)
app.mount('#app')
